export default "__VITE_ASSET__5daa65cf__"